var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-panel',{attrs:{"title":"Instructional Settings"}},[_c('p-instructional-settings',{attrs:{"isEdit":_vm.isEdit,"instructionalSettings":_vm.instructionalSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }